export default "__VITE_ASSET__a792db61__"